export const input_types = {
  SLIDER: 'slider',
  RANGE: 'range',
  YEAR_RANGE: 'year_range',
  CHECKBOX: 'checkbox',
  RADIO: 'radio',
  NESTED_CHECKBOX: 'nested_checkbox',
  TOGGLE: 'toggle',
};

// Used in Workspaces -- Match entityType to corresponding ElasticSearch field name we need to filter against
export const fieldTypes = {
  publication: 'id',
  patent: 'id',
  author: 'author_ids',
  inventor: 'inventor_ids',
  assignee: 'assignee_ids',
};

export const filterDefinitions = {
  publication: {
    threshold: {
      type: input_types.SLIDER,
      label: 'Similarity Threshold',
      inFilterList: true,
      scanType: ['semantic'],
    },
    venue_name: {
      type: input_types.CHECKBOX,
      label: 'Journals',
      inFilterList: true,
      scanType: ['boolean', 'semantic'],
    },
    ['concepts.display_name']: {
      type: input_types.CHECKBOX,
      label: 'Concepts',
      inFilterList: true,
      nested: true, // This filter is on a nested field
      scanType: ['boolean', 'semantic'],
    },
    affiliation_types: {
      type: input_types.NESTED_CHECKBOX,
      label: 'Institution Types',
      inFilterList: true,
      scanType: ['boolean', 'semantic'],
    },
    citation_count: {
      type: input_types.RANGE,
      label: 'Citation Range',
      inFilterList: true,
      scanType: ['boolean', 'semantic'],
    },
    publication_year: {
      type: input_types.YEAR_RANGE,
      label: 'Publication Year',
      inFilterList: true,
      scanType: ['boolean', 'semantic'],
    },
    type: {
      type: input_types.CHECKBOX,
      label: 'Publication Type',
      inFilterList: true,
      scanType: ['boolean', 'semantic'],
    },
    'advisories.advisory_type': {
      type: input_types.CHECKBOX,
      label: 'Advisory Types',
      inFilterList: true,
      nested: true, // This filter is on a nested field
      scanType: ['boolean', 'semantic'],
    },
    author_affiliation_country_names: {
      type: input_types.CHECKBOX,
      label: 'Coauthor Countries',
      inFilterList: true,
      scanType: ['boolean', 'semantic'],
    },
    author_affiliation_state_names: {
      type: input_types.CHECKBOX,
      label: 'Coauthor States',
      inFilterList: true,
      scanType: ['boolean', 'semantic'],
    },
    author_affiliation_names: {
      type: input_types.CHECKBOX,
      label: 'Coauthor Institutions',
      inFilterList: true,
      scanType: ['boolean', 'semantic'],
    },
    author_names: {
      type: input_types.CHECKBOX,
      label: 'Coauthors',
      inFilterList: true,
      scanType: ['boolean', 'semantic'],
    },
    funder_names: {
      type: input_types.CHECKBOX,
      label: 'Funders',
      inFilterList: true,
      scanType: ['boolean', 'semantic'],
    },
    search_within_results: {
      type: '',
      label: 'Keyword',
      inFilterList: false,
      scanType: ['boolean', 'semantic'],
    },
    positive: {
      type: '',
      label: 'More Like',
      inFilterList: false,
      scanType: ['semantic'],
    },
    negative: {
      type: '',
      label: 'Less Like',
      inFilterList: false,
      scanType: ['semantic'],
    },
  },
  patent: {
    threshold: {
      type: input_types.SLIDER,
      label: 'Similarity Threshold',
      inFilterList: true,
      scanType: ['semantic'],
    },
    filing_year: {
      type: input_types.YEAR_RANGE,
      label: 'Filing Year',
      inFilterList: true,
      scanType: ['boolean', 'semantic'],
    },
    priority_year: {
      type: input_types.YEAR_RANGE,
      label: 'Priority Year',
      inFilterList: true,
      scanType: ['boolean', 'semantic'],
    },
    granted_year: {
      type: input_types.YEAR_RANGE,
      label: 'Granted Year',
      inFilterList: true,
      scanType: ['boolean', 'semantic'],
    },
    citation_count: {
      type: input_types.RANGE,
      label: 'Citation Range',
      inFilterList: true,
      scanType: ['boolean', 'semantic'],
    },
    kind_code_name: {
      type: input_types.CHECKBOX,
      label: 'Kind Code',
      inFilterList: true,
      scanType: ['boolean', 'semantic'],
    },
    status: {
      type: input_types.CHECKBOX,
      label: 'Status',
      inFilterList: true,
      scanType: ['boolean', 'semantic'],
    },
    authority_name: {
      type: input_types.CHECKBOX,
      label: 'Authority',
      inFilterList: true,
      scanType: ['boolean', 'semantic'],
    },
    inventor_names: {
      type: input_types.CHECKBOX,
      label: 'Inventors',
      inFilterList: true,
      scanType: ['boolean', 'semantic'],
    },
    inventor_country_names: {
      type: input_types.CHECKBOX,
      label: 'Inventor Countries',
      inFilterList: true,
      scanType: ['boolean', 'semantic'],
    },
    inventor_state_names: {
      type: input_types.CHECKBOX,
      label: 'Inventor States',
      inFilterList: true,
      scanType: ['boolean', 'semantic'],
    },
    assignee_names: {
      type: input_types.CHECKBOX,
      label: 'Assignees',
      inFilterList: true,
      scanType: ['boolean', 'semantic'],
    },
    assignee_country_names: {
      type: input_types.CHECKBOX,
      label: 'Assignee Countries',
      inFilterList: true,
      scanType: ['boolean', 'semantic'],
    },
    assignee_state_names: {
      type: input_types.CHECKBOX,
      label: 'Assignee States',
      inFilterList: true,
      scanType: ['boolean', 'semantic'],
    },
    cpc_codes: {
      type: input_types.CHECKBOX,
      label: 'CPC Codes',
      inFilterList: true,
      scanType: ['boolean', 'semantic'],
    },
    search_within_results: {
      type: '',
      label: 'Keyword',
      inFilterList: false,
      scanType: ['boolean', 'semantic'],
    },
    positive: {
      type: '',
      label: 'More Like',
      inFilterList: false,
      scanType: ['semantic'],
    },
    negative: {
      type: '',
      label: 'Less Like',
      inFilterList: false,
      scanType: ['semantic'],
    },
  },
  funding: {
    threshold: {
      type: input_types.SLIDER,
      label: 'Similarity Threshold',
      inFilterList: true,
      scanType: ['semantic'],
    },
    funding_us_fiscal_year: {
      type: input_types.YEAR_RANGE,
      label: 'Funding Year',
      inFilterList: true,
      scanType: ['boolean', 'semantic'],
    },
    funding_amount: {
      type: input_types.RANGE,
      label: 'Funding Amount',
      inFilterList: true,
      scanType: ['boolean', 'semantic'],
    },
    category: {
      type: input_types.CHECKBOX,
      label: 'Funding Categories',
      inFilterList: true,
      scanType: ['boolean', 'semantic'],
    },
    type: {
      type: input_types.CHECKBOX,
      label: 'Funding Types',
      inFilterList: true,
      scanType: ['boolean', 'semantic'],
    },
    psc_codes: {
      type: input_types.CHECKBOX,
      label: 'PSC Codes',
      inFilterList: true,
      scanType: ['boolean', 'semantic'],
    },
    recipient_names: {
      type: input_types.CHECKBOX,
      label: 'Recipients',
      inFilterList: true,
      scanType: ['boolean', 'semantic'],
    },
    recipient_types: {
      type: input_types.CHECKBOX,
      label: 'Recipient Types',
      inFilterList: true,
      scanType: ['boolean', 'semantic'],
    },
    recipient_countries: {
      type: input_types.CHECKBOX,
      label: 'Recipient Countries',
      inFilterList: true,
      scanType: ['boolean', 'semantic'],
      countryCode: true,
    },
    recipient_states: {
      type: input_types.CHECKBOX,
      label: 'Recipient States',
      inFilterList: true,
      scanType: ['boolean', 'semantic'],
      stateCode: true,
    },
    funder_names: {
      type: input_types.CHECKBOX,
      label: 'Funders',
      inFilterList: true,
      scanType: ['boolean', 'semantic'],
    },
    funder_types: {
      type: input_types.CHECKBOX,
      label: 'Funder Types',
      inFilterList: true,
      scanType: ['boolean', 'semantic'],
    },
    funder_countries: {
      type: input_types.CHECKBOX,
      label: 'Funder Countries',
      inFilterList: true,
      scanType: ['boolean', 'semantic'],
      countryCode: true,
    },
    funder_states: {
      type: input_types.CHECKBOX,
      label: 'Funder States',
      inFilterList: true,
      scanType: ['boolean', 'semantic'],
      stateCode: true,
    },
    search_within_results: {
      type: '',
      label: 'Keyword',
      inFilterList: false,
      scanType: ['boolean', 'semantic'],
    },
  },
  fundingPublication: {
    threshold: {
      type: input_types.SLIDER,
      label: 'Similarity Threshold',
      inFilterList: true,
      scanType: ['semantic'],
    },
    publication_year: {
      type: input_types.YEAR_RANGE,
      label: 'Funding Year',
      inFilterList: true,
      scanType: ['boolean', 'semantic'],
    },
    'advisories.advisory_type': {
      type: input_types.CHECKBOX,
      label: 'Advisory Types',
      inFilterList: true,
      nested: true, // This filter is on a nested field
      scanType: ['boolean', 'semantic'],
    },
    author_affiliation_names: {
      type: input_types.CHECKBOX,
      label: 'Recipients',
      inFilterList: true,
      scanType: ['boolean', 'semantic'],
    },
    affiliation_types: {
      type: input_types.CHECKBOX,
      label: 'Recipient Types',
      inFilterList: true,
      scanType: ['boolean', 'semantic'],
    },
    author_affiliation_country_names: {
      type: input_types.CHECKBOX,
      label: 'Recipient Countries',
      inFilterList: true,
      scanType: ['boolean', 'semantic'],
    },
    author_affiliation_state_names: {
      type: input_types.CHECKBOX,
      label: 'Recipient States',
      inFilterList: true,
      scanType: ['boolean', 'semantic'],
    },
    funder_names: {
      type: input_types.CHECKBOX,
      label: 'Funders',
      inFilterList: true,
      scanType: ['boolean', 'semantic'],
    },
    funder_types: {
      type: input_types.CHECKBOX,
      label: 'Funder Types',
      inFilterList: true,
      scanType: ['boolean', 'semantic'],
    },
    funder_countries: {
      type: input_types.CHECKBOX,
      label: 'Funder Countries',
      inFilterList: true,
      scanType: ['boolean', 'semantic'],
      countryCode: true,
    },
    funder_states: {
      type: input_types.CHECKBOX,
      label: 'Funder States',
      inFilterList: true,
      scanType: ['boolean', 'semantic'],
      stateCode: true,
    },
    search_within_results: {
      type: '',
      label: 'Keyword',
      inFilterList: false,
      scanType: ['boolean', 'semantic'],
    },
  },
};
